import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Fonts — self-hosted via @fontsource (replaces Google Fonts CDN link)
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

// Fix ResizeObserver issues before any components load
import './utils/resizeObserverFix';

// import i18n (needs to be bundled ;))
import './i18n';

// Suppress ResizeObserver loop errors
// These errors are benign and occur when ResizeObserver cannot deliver all notifications within a single animation frame
// This is a known issue with ResizeObserver and can be safely ignored
const errorHandler = (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded') {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) {
            resizeObserverErr.style.display = 'none';
        }
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.style.display = 'none';
        }
        // Prevent the error from being logged to console in development
        e.stopPropagation();
        e.preventDefault();
        return true;
    }
};

// Add error event listener
window.addEventListener('error', errorHandler);

// Also handle unhandled promise rejections that might contain this error
window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && 
        (e.reason.message.includes('ResizeObserver loop completed with undelivered notifications') ||
         e.reason.message.includes('ResizeObserver loop limit exceeded'))) {
        e.preventDefault();
        return true;
    }
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
            <App/>
    </React.StrictMode>,
);
